/*************************************************/
/* CUSTOMCURSOR                                  */
/*************************************************/

export function customCursor(customCursorItemSelector, cursorSelector = ".custom-cursor") {
    // if (window.matchMedia("(max-width: 768px)").matches) return;

    const customCursor = document.querySelector(cursorSelector);
    if (!customCursor) {
        console.error(`Cursor element "${cursorSelector}" not found.`);
        return;
    }

    const customCursorSize = 72;

    // Ensure cursor is hidden initially
    customCursor.style.position = "absolute";
    customCursor.style.pointerEvents = "none";
    customCursor.style.opacity = "0";
    customCursor.style.zIndex = "9999";
    customCursor.style.transformOrigin = "center center";
    customCursor.style.width = "0px";
    customCursor.style.height = "0px";
    customCursor.style.transition = "width 0.3s ease-out, height 0.3s ease-out, opacity 0.3s ease-out";

    document.querySelectorAll(customCursorItemSelector).forEach(box => {
        const updateCursorPosition = (event) => {
            requestAnimationFrame(() => {
                const mouseX = event.pageX - customCursorSize / 2;
                const mouseY = event.pageY - customCursorSize / 2;

                customCursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
                customCursor.style.opacity = "1";
            });
        };

        const handleMouseEnter = () => {
            requestAnimationFrame(() => {
                customCursor.style.width = `${customCursorSize}px`;
                customCursor.style.height = `${customCursorSize}px`;
                customCursor.style.opacity = "1";
            });
        };

        const handleMouseLeave = () => {
            requestAnimationFrame(() => {
                customCursor.style.opacity = "0";
                customCursor.style.width = "0px";
                customCursor.style.height = "0px";
            });
        };

        box.addEventListener("mouseenter", handleMouseEnter);
        box.addEventListener("mousemove", updateCursorPosition);
        box.addEventListener("mouseleave", handleMouseLeave);
    });
}
